module.exports = __webpack_public_path__ + "static/media/Streamer01-640-480.fea458d0.jpg";